import React, { useEffect, useState } from "react";
import MDTypography from "components/MDTypography";
import {
  IconButton,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  DialogContent,
  TextField,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";

function AgentContactUpdate({
  row,
  setUpdateList,
  callCenter,
  onChange
}) {
  const contactForCallcenter = row?.original?.contact;
  const agentNameForCallCenter = row?.original?.name;
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [showAlert, setShowAlert] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [contactValue, setContactValue] = useState("");
  const [timeoutValue, setTimeoutValue] = useState("");

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  useEffect(() => {
    if (!showAlert) {
      setNotify({
        isOpen: false,
        message: "",
        type: "",
        pagename: "",
        status: "",
      });
    }
  }, [showAlert]);

  const extractTimeout = (contactString) => {
    const match = contactString?.match(/call_timeout=(\d+)/);
    return match ? match[1] : "";
  };

  const handleFinalSubmit = () => {
    setShowAlert(true);
  };

  const handleSubmit = () => {
    if (!selectedType) {
      setNotify({
        isOpen: true,
        status: "Please First Select Type In Dropdown",
        type: "warning",
        pagename: "Agent Contact",
      });
      return;
    }
    if (selectedType === "Timeout" && !timeoutValue) {
      setNotify({
        isOpen: true,
        status: "Please Fill The Timeout Value",
        type: "warning",
        pagename: "Agent Contact",
      });
      return;
    }

    if (selectedType === "Contact" && !contactValue) {
      setNotify({
        isOpen: true,
        status: "Please Fill The Contact Value",
        type: "warning",
        pagename: "Agent Contact",
      });
      return;
    }

    let contactData = {};

    if (selectedType === "Contact") {
      contactData = {
        agentName: callCenter ? agentNameForCallCenter : row?.agent,
        newContact: contactValue,
      };
    } else if (selectedType === "Timeout") {
      contactData = {
        agentName: callCenter ? agentNameForCallCenter : row?.agent,
        newCallTimeout: timeoutValue,
      };
    }
    application
      .post("/agent/updateAgentContact", contactData)
      .then((response) => {
        if (callCenter) {
          onChange()
        } else {
          setUpdateList(Date.now());
        }
        setNotify({
          isOpen: true,
          status: response?.data?.messageDetail + " " + response?.data?.message,
          type: "success",
          pagename: "Agent Contact",
        });
        setSelectedType("");
        setContactValue("");
        setTimeoutValue("");

        setTimeout(() => {
          setShowAlert(false);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error While the Contact Update & Time Update", error);
        setNotify({
          isOpen: true,
          status:
            error?.response?.data?.messageDetail +
            " " +
            error?.response?.data?.message,
          type: "success",
          pagename: "Agent Contact",
        });
      });
  };

  const handleCancel = () => {
    setShowAlert(false);
    setSelectedType("");
    setContactValue("");
    setTimeoutValue("");
  };

  const handleChange = (event) => {
    const type = event.target.value;
    setSelectedType(type);
    if (type === "Contact") {
      setContactValue(callCenter ? contactForCallcenter : row.contact || "");
    } else if (type === "Timeout") {
      setTimeoutValue(
        extractTimeout(callCenter ? contactForCallcenter : row.contact || "")
      );
    }
  };

  return (
    <>
      <MDTypography variant="caption" fontWeight="medium" color="text">
        <tooltip title="Contact Update">
          <IconButton color="success" onClick={handleFinalSubmit}>
            <OpenInNewIcon />
          </IconButton>
        </tooltip>
      </MDTypography>

      <Dialog
        open={showAlert}
        onClose={handleCancel}
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          id="alert-dialog-title"
        >
          Agent Contact Update:{row.agent}
        </DialogTitle>

        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Type</InputLabel>
            <Select
              value={selectedType}
              onChange={handleChange}
              label="Select Type"
              sx={{ height: 55 }}
            >
              <MenuItem value="Contact">Contact</MenuItem>
              <MenuItem value="Timeout">Timeout</MenuItem>
            </Select>
          </FormControl>

          <MDBox sx={{ mt: 3, width: 400 }}>
            {selectedType === "Contact" && (
              <TextField
                id="outlined-multiline-static"
                label="Contact Info"
                multiline
                rows={4}
                fullWidth
                onChange={(e) => setContactValue(e.target.value)}
                value={contactValue}
              />
            )}

            {selectedType === "Timeout" && (
              <TextField
                label="Timeout Value"
                fullWidth
                value={timeoutValue}
                onChange={(e) => setTimeoutValue(e.target.value)}
              />
            )}
          </MDBox>
        </DialogContent>

        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleCancel} color="secondary">
            Cancel
          </MDButton>
          <MDButton onClick={handleSubmit} color="success" autoFocus>
            Submit
          </MDButton>
        </DialogActions>
        <CTLNotification notify={notify} setNotify={setNotify} />
      </Dialog>
    </>
  );
}

export default AgentContactUpdate;
